import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-weight-bold mb-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BFormTextarea = _resolveComponent("BFormTextarea");
    const _component_Field = _resolveComponent("Field");
    const _component_ErrorMessage = _resolveComponent("ErrorMessage");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tr('viiu.componentMuting.REASON_FOR_MUTING')), 1),
        _createVNode(_component_Field, {
            "model-value": _ctx.modelValue,
            rules: _ctx.Validator.MAX(200),
            name: _ctx.tr('viiu.componentMuting.REASON_FOR_MUTING'),
            "validate-on-input": "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:modelValue', value))
        }, {
            default: _withCtx(({ field, meta }) => [
                _createVNode(_component_BFormTextarea, _mergeProps(field, {
                    placeholder: _ctx.placeholder,
                    state: _ctx.getStateForComponentValidation(meta),
                    rows: "4"
                }), null, 16, ["placeholder", "state"])
            ]),
            _: 1
        }, 8, ["model-value", "rules", "name"]),
        _createVNode(_component_ErrorMessage, {
            name: _ctx.tr('viiu.componentMuting.REASON_FOR_MUTING'),
            as: "div",
            class: "text-danger mt-1"
        }, null, 8, ["name"])
    ]));
}
